
/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES
import Http from '../services/Http';

// private sector
let $http;

//public sector
export default class StudentRepo {

    static $resource = 'students';
    
    constructor($auth){
        $http = new Http($auth);        
    }

    show(id){
        return $http.get(StudentRepo.$resource + "/" + id + "?include=school").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    store(data){
        return $http.post(StudentRepo.$resource, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    all(){
        return $http.get(StudentRepo.$resource + "?include=school").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    paginate(page, q, orderBy){
        let query = "page=" + page + "&include=school";
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(StudentRepo.$resource + "/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    update(id, data){
        return $http.put(StudentRepo.$resource + "/" + id, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    delete(id){
        return $http.delete(StudentRepo.$resource + "/" + id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/repos/StudentRepo.js